import { 
  deleteCliente, 
  getClientesPanel, 
  permitirEdicion,  // ← NUEVO
} from "../../services/ClientesServices";
import { ClientesContext } from "./ClientesContext"

export const ClientesState = ({ children }) => {
    const getClientesPanelData = async (search, searchCli, numpag, filas) => {
        let res = await getClientesPanel(search, searchCli, numpag, filas)
        return res
    }  
    
    const deleteClienteData = async (body, numpag, filas, search) => {
        const res = await deleteCliente(body)
        if (res) getClientesPanelData(numpag, filas, search)
        return res
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // NUEVO: Asignar zonas a clientes de un emp
    // ═══════════════════════════════════════════════════════════════════════════
    const permitirEdicionCompleta = async (emp_id,option) => { 
        const res = await permitirEdicion(emp_id,option)
        return res
    }

    return <ClientesContext.Provider value={{
        deleteClienteData,
        getClientesPanelData,
        permitirEdicionCompleta,  // ← NUEVO
    }} >
        {children}
    </ClientesContext.Provider>
}
